"use client";

import { MissionList } from "./MissionList";
import "styles/mission.css";
import { useStaticStore } from "app/hooks";
import { STORE_KEYS } from "app/constants";
import { MdClose } from "react-icons/md";

export function PopupContentMission() {
  const { mutate: setIsOpen } = useStaticStore(STORE_KEYS.popup);
  return (
    <>
      <a className="mission-modal-close" onClick={() => setIsOpen(false)}>
        <MdClose aria-label="閉じる" size={24} className="mission-modal-close-icon" />
      </a>
      <div className="dialog-content mission-modal">
        <div className="mission-modal-content-wrap">
          <div className="mission-h">
            <h2 className="mission-h-h">
              <span className="mission-h-text">ミッション</span>
            </h2>
            <p className="mission-h-desc">
              条件を達成して
              <br />
              「すぐ無料チケット」をGET!
            </p>
            <p className="mission-h-note">※チケットは自動的に付与されます</p>
          </div>
          <MissionList isPopUp={true} />
        </div>
      </div>
    </>
  );
}
